import React, { useEffect, useState } from "react";
import { Link, matchPath, Navigate, Outlet } from "react-router-dom";
import MeetingRejoin from "../components/MeetingRejoin";
import MonteChat from "../components/MonteChat";
import StarpilotChat from "../components/StarpilotChat";
import { useNavigate, useLocation } from "react-router-dom";
import useIdleTimer from "../hooks/useIdleTimer";
import { logout } from "../api/apiHandler";
import { logOutRedirectCall } from "../../src/pages/patient/common/RedirectPathMange";
import { InActivityPopup } from "../modal/InActivityPopup";

const AuthLayout = ({ chat, setChat }) => {
  const location = useLocation();
  let navigate = useNavigate();

  const userRole = localStorage.getItem("user_login_type_role");

  const pathname = location.pathname;

  const [inactive, setInactive] = useState(false);
  const handleInactive = () => {
    setInactive(true);
  };
  const handleIdle = () => {
    setInactive(false);
    logout({})
      .then((res) => {
        try {
          const response = JSON.parse(res);
          if (response.code === process.env.REACT_APP_SUCCESS) {
            logOutRedirectCall();
          }
        } catch (error) {
          console.error("Logout response parsing error:", error);
        }
      })
      .catch((err) => {
        console.error("Logout API error:", err);
      });
  };

  useEffect(() => {
    if (inactive) {
      const timer = setTimeout(() => {
        handleIdle();
      }, 300000);

      return () => clearTimeout(timer);
    }
  }, [inactive]);

  useIdleTimer(300000, handleInactive);

  console.log("location--->", location.pathname);
  return (
    <>
      <InActivityPopup inactive={inactive} setInactive={setInactive} />
      <div>
        {!location.pathname.includes(`/meeting/`) &&
          location.pathname != "/meeting" &&
          location.pathname != "/meetingv2" &&
          location.pathname != "/meetingmini" &&
          location.pathname != "/patient/splash-screen" &&
          location.pathname != "/meeting-single-mic" &&
          location.pathname != "/doctor/splash-screen" &&
          location.pathname != "/meetingo3mini" &&
          location.pathname != "/meeting-trsln" &&
          location.pathname != "/meeting-trspt" && (
            <MonteChat chat={chat} setChat={setChat} />
          )}

        {!location.pathname.includes(`/meeting/`) &&
          location.pathname != "/meeting" &&
          location.pathname != "/meetingv2" &&
          location.pathname != "/meetingmini" &&
          location.pathname != "/meeting-single-mic" &&
          location.pathname != "/patient/splash-screen" &&
          location.pathname != "/doctor/splash-screen" &&
          location.pathname != "/meetingo3mini" &&
          location.pathname != "/meeting-trsln" &&
          location.pathname != "/meeting-trspt" && <MeetingRejoin />}

        <Outlet />
      </div>
    </>
  );
};

export default AuthLayout;
